export const apiActionTypes = {
    API_ERROR: 'API_ERROR',
} as const;
